import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const ExpandIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 33 32" {...props}>
    <path
      d="M19 8.5H24V13.5"
      stroke="#5D5F68"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 23.5H9V18.5"
      stroke="#5D5F68"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.9993 8.5L18.166 14.3333"
      stroke="#5D5F68"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 23.5001L14.8333 17.6667"
      stroke="#5D5F68"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default ExpandIcon;
